import { useContext, useEffect, useState } from "react";
import { STEP_GROUP_IDS } from "../../../shared/config";
import { ProcessContext } from "../../../../contexts/ProcessContext";
import { useStepHandler } from "../../../../utils/hooks/useStepHandler";
import { UserDetailsWithIdDocumentVerificationFormDataMapper } from "../../../../utils/mappers/MainUserDetails/UserDetailsWithIdDocumentVerificationFormDataMapper";

export const useDocumentIdVerification = ({ stepGroupStepsArray }) => {
  const {
    state: {
      loan,
      lastActionsReferenceLastChange,
      lastActionsReference,
      participant,
      idDocumentVerification,
    },
    dispatch,
  } = useContext(ProcessContext);

  const [state, setState] = useState({ formSubmitSuccess: false });
  const { formSubmitSuccess } = state;

  const CURRENT_STEP_GROUP = STEP_GROUP_IDS.DocumentIdVerification;

  const onSubmitModule = (values) => {
    const newValues = {
      ...values,
      address: { ...values.address, ...values.complementAddress },
    };

    const payload =
      UserDetailsWithIdDocumentVerificationFormDataMapper.reverseMap(
        {
          ...newValues,
          loan,
          documentType:
            idDocumentVerification?.documentType ??
            idDocumentVerification?.extractedData?.document_type,
        },
        participant
      );

    dispatch({ type: "SET_FLOW_LOADING", payload: { show: true } });
    dispatch({
      type: "REQUEST_PATCH_SET_USER_DETAILS_WITH_ID_DOCUMENT_VERIFICATION_FORM_DATA",
      payload,
    });
  };

  const currentModuleStepHandler = useStepHandler(onSubmitModule, {});
  const { manageGroup, submitStep, onBack, backButtonVisible, getStepData } =
    currentModuleStepHandler;

  const handleBack = (...args) => {
    dispatch({ type: "CLEAR_ID_DOCUMENT_VERIFICATION_ERROR" });
    onBack?.(...args);
  };

  const stepGroupStepToShow = manageGroup(
    CURRENT_STEP_GROUP,
    stepGroupStepsArray
  );

  useEffect(() => {
    const isActionTypeInLastActionsReference = (actionType) =>
      lastActionsReference?.some((element) => element.type === actionType);

    if (formSubmitSuccess) {
      if (isActionTypeInLastActionsReference("REQUEST_GET_LOAN_FULFILLED")) {
        dispatch({ type: "SET_FLOW_ITEM_OK" });
      }
    }
    if (
      isActionTypeInLastActionsReference(
        "REQUEST_PATCH_SET_USER_DETAILS_WITH_ID_DOCUMENT_VERIFICATION_FORM_DATA_FULFILLED"
      )
    ) {
      setState((s) => ({ ...s, formSubmitSuccess: true }));
    }
  }, [formSubmitSuccess, lastActionsReferenceLastChange]);

  return {
    stepGroupStepToShow,
    submitStep,
    onBack: handleBack,
    backButtonVisible,
    getStepData,
    currentModuleStepHandler,
  };
};
